export var paylinkReportsDetailsMapper = function (data) {
    var result = [];
    if (data && data.length > 0) {
        result = data.map(function (item) {
            return {
                SrNo: item.SrNo,
                CreatedDate: item.CreatedDate,
                ClientCode: item.ClientCode,
                AmountRequested: item.AmountRequested,
                AmountAttempted: item.AmountAttempted,
                Link: item.Link,
                CurrentStatusOfLink: item.CurrentStatusOfLink,
                ClickedByUser: item.ClickedByUser,
                MoneyTransferedAttempted: item.MoneyTransferedAttempted,
                EwPgRefNo: item.EwPgRefNo,
                BankStatus: item.BankStatus,
                Source: item.Source,
                Reason: item.Reason,
                StakeHolder: item.StakeHolder,
                KillLink: item.KillLink
            };
        });
    }
    return result;
};
